module.exports = __webpack_public_path__ + "img/imghuiytj-xz.6d1ed10a.png";